import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { TacticalLabel } from './TacticalLabel';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 300]);
  return <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-sapper-dark pt-20" data-id="element-168">
      {/* Parallax Background */}
      <motion.div className="absolute inset-0 z-0" style={{
      y
    }} data-id="element-169">
        <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/ekf3Ue5UESW4yKX2H7iiuw/sapper-package.png')] bg-cover bg-center" data-id="element-170" />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-sapper-dark via-sapper-dark/80 to-transparent" data-id="element-171" />
        <div className="absolute inset-0 bg-gradient-to-t from-sapper-dark via-transparent to-sapper-dark/40" data-id="element-172" />
      </motion.div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 flex-grow flex flex-col justify-center py-20" data-id="element-173">
        <div className="max-w-3xl" data-id="element-174">
          <TacticalLabel className="mb-6" data-id="element-175">
            OPERATING IN PHOENIX METRO // EST. ARIZONA
          </TacticalLabel>

          <h1 className="font-condensed font-black text-6xl sm:text-7xl md:text-8xl lg:text-9xl text-sapper-white uppercase leading-[0.9] tracking-tighter mb-6" data-id="element-176">
            WE CLEAR
            <br data-id="element-177" />
            <span className="text-sapper-red" data-id="element-178">THE HEAT.</span>
          </h1>

          <p className="font-sans text-lg sm:text-xl md:text-2xl text-sapper-white/90 font-light max-w-2xl mb-10 leading-relaxed" data-id="element-179">
            Phoenix Metro's installation specialists. Veteran-grade HVAC
            service. Mission-ready since day one.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-180">
            <a href="#contact" className="inline-flex items-center justify-center bg-sapper-red text-sapper-white font-condensed font-bold text-xl px-8 py-4 uppercase tracking-wider hover:bg-red-700 transition-colors" data-id="element-181">
              DEPLOY A CREW
            </a>
            <a href="tel:4805550199" className="inline-flex items-center justify-center border-2 border-sapper-white text-sapper-white font-condensed font-bold text-xl px-8 py-4 uppercase tracking-wider hover:bg-sapper-white hover:text-sapper-dark transition-colors" data-id="element-182">
              (480) 555-0199. CALL NOW
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Stat Strip */}
      <div className="relative z-10 border-t border-sapper-olive/30 bg-sapper-dark/80 backdrop-blur-sm" data-id="element-183">
        <div className="container mx-auto px-4" data-id="element-184">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-sapper-olive/30 border-x border-sapper-olive/30" data-id="element-185">
            <div className="py-4 px-4 text-center" data-id="element-186">
              <div className="font-mono text-sapper-white text-sm sm:text-base font-bold tracking-wider" data-id="element-187">
                5,000+
              </div>
              <div className="font-mono text-sapper-gray text-xs mt-1" data-id="element-188">
                HOMES SERVICED
              </div>
            </div>
            <div className="py-4 px-4 text-center" data-id="element-189">
              <div className="font-mono text-sapper-white text-sm sm:text-base font-bold tracking-wider" data-id="element-190">
                4.9★
              </div>
              <div className="font-mono text-sapper-gray text-xs mt-1" data-id="element-191">
                GOOGLE RATED
              </div>
            </div>
            <div className="py-4 px-4 text-center" data-id="element-192">
              <div className="font-mono text-sapper-white text-sm sm:text-base font-bold tracking-wider" data-id="element-193">
                24/7
              </div>
              <div className="font-mono text-sapper-gray text-xs mt-1" data-id="element-194">
                EMERGENCY OPS
              </div>
            </div>
            <div className="py-4 px-4 text-center" data-id="element-195">
              <div className="font-mono text-sapper-white text-sm sm:text-base font-bold tracking-wider" data-id="element-196">
                100%
              </div>
              <div className="font-mono text-sapper-gray text-xs mt-1" data-id="element-197">
                SATISFACTION
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-24 right-8 hidden md:flex flex-col items-center gap-2 opacity-50" data-id="element-198">
        <span className="font-mono text-xs text-sapper-white tracking-widest" style={{
        writingMode: 'vertical-rl'
      }} data-id="element-199">
          SCROLL
        </span>
        <ChevronDown className="w-4 h-4 text-sapper-white animate-bounce" data-id="element-200" />
      </div>
    </section>;
}